'use client';

import { createContext, useContext } from 'react';

import type { MeResponse } from '@/api/queries/me';

const MeContext = createContext<MeResponse | null>(null);

export function MeProvider({
  data,
  children,
}: {
  readonly data: MeResponse;
  readonly children: React.ReactNode;
}) {
  return <MeContext.Provider value={data}>{children}</MeContext.Provider>;
}

export function useMe() {
  const ctx = useContext(MeContext);
  if (!ctx) {
    throw new Error('useMe must be used within MeProvider');
  }
  return ctx;
}
